import { ProductVariantType } from './types'

const unescapeMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&#34;': '"',
  '&#39;': "'",
}
function unescape(str: string) {
  return String(str).replace(/&(amp|lt|gt|#34|#39);/g, (m) => unescapeMap[m])
}
export default class OrderCart {
  productVariants: ProductVariantType[]
  couponCode: string

  constructor() {
    this.productVariants = []
  }

  dispatchOrderSummaryLegacyUpdate(): void {
    const event = new CustomEvent('OrderSummaryLegacyRender', {
      detail: {
        orderCart: this,
      },
    })
    document.dispatchEvent(event)
  }

  dispatchOrderSummaryUpdate(): void {
    const event = new CustomEvent('OrderSummaryRender', {
      detail: {
        orderCart: this,
      },
    })
    document.dispatchEvent(event)
  }

  updateProductVariant(newProductVariant: ProductVariantType): void {
    let cartUpdated
    this.productVariants = this.productVariants.map((product) => {
      if (newProductVariant.id == product.id) {
        cartUpdated = true
        return newProductVariant
      }
      return product
    })
    if (!cartUpdated) {
      this.productVariants.push(newProductVariant)
    }
    this.cleanUp()

    this.dispatchOrderSummaryUpdate()
    this.dispatchOrderSummaryLegacyUpdate()
  }

  removeProductVariant(id: string): void {
    this.productVariants = this.productVariants.filter((variant) => id !== variant.id)
    this.dispatchOrderSummaryUpdate()
    this.dispatchOrderSummaryLegacyUpdate()
  }

  removeAllProductVariants(): void {
    this.productVariants = []
    this.dispatchOrderSummaryUpdate()
    this.dispatchOrderSummaryLegacyUpdate()
  }

  getProductVariant(input: HTMLInputElement, type = 'single'): ProductVariantType {
    let quantity: number
    const id = input.getAttribute('data-product-variant-id')
    const name = input.getAttribute('data-product-variant-name')
    const image = input.getAttribute('data-product-variant-image')
    const productType = input.getAttribute('data-product-variant-product-type')
    const currency = input.getAttribute('data-product-variant-price-currency')
    const priceId = Number(input.getAttribute('data-product-variant-price-id'))
    const priceCents = Number(input.getAttribute('data-product-variant-price-cents'))
    const prices = JSON.parse(unescape(input.getAttribute('data-product-variant-prices')) ?? '[]')

    if (input.type == 'checkbox') {
      quantity = Number(input.checked)
    } else if (type == 'single') {
      quantity = 1
    } else {
      quantity = Number(input.value)
    }
    return {
      id,
      name,
      quantity,
      currency,
      image,
      priceCents,
      priceId,
      productType,
      prices,
    }
  }

  updateProductVariantQuantity(id: string, quantity: number): void {
    this.productVariants = this.productVariants.map((p) => (p.id === id ? { ...p, quantity: quantity } : p))
    this.cleanUp()
    this.dispatchOrderSummaryUpdate()
    this.dispatchOrderSummaryLegacyUpdate()
  }

  incrementProductVariantQuantity(product: ProductVariantType, increment: number): void {
    this.productVariants = this.productVariants.map((p) =>
      p.id === product.id ? { ...p, quantity: p.quantity + increment } : p
    )
    this.cleanUp()
    this.dispatchOrderSummaryUpdate()
    this.dispatchOrderSummaryLegacyUpdate()
  }

  updateCouponCode(couponCode: string): void {
    this.couponCode = couponCode
    this.dispatchOrderSummaryUpdate()
    this.dispatchOrderSummaryLegacyUpdate()
  }

  totalCents(): number {
    return this.productVariants.reduce(function (acc, product) {
      return acc + product.quantity * product.priceCents
    }, 0)
  }

  clear(): void {
    this.productVariants = []
  }

  cleanUp(): void {
    this.productVariants = this.productVariants.filter((p) => p.quantity > 0)
  }
}
